import { useEffect, useState } from 'react';
import kuromoji from 'kuromoji';

type Tokenizer = kuromoji.Tokenizer<kuromoji.IpadicFeatures>;

let tokenizerPromise: Promise<Tokenizer> | null = null;

const getTokenizer = (): Promise<Tokenizer> => {
  if (!tokenizerPromise) {
    tokenizerPromise = new Promise((resolve, reject) => {
      kuromoji.builder({ dicPath: '/dict' }).build((err, tokenizer) => {
        if (err) reject(err);
        else resolve(tokenizer);
      });
    });
  }
  return tokenizerPromise;
};

const katakanaToHiragana = (str: string) =>
  str.replace(/[ァ-ヶ]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0x60));

const mergeCompoundTokens = (tokens: kuromoji.IpadicFeatures[]): kuromoji.IpadicFeatures[] => {
  const result: kuromoji.IpadicFeatures[] = [];
  for (const token of tokens) {
    if (result.length > 0 && token.pos === '名詞' && token.pos_detail_1 === '接尾') {
      const prev = result[result.length - 1];
      result[result.length - 1] = {
        ...prev,
        surface_form: prev.surface_form + token.surface_form,
        reading: (prev.reading ?? '') + (token.reading ?? ''),
      };
    } else {
      result.push(token);
    }
  }
  return result;
};

export default function useKuromoji() {
  const [tokenizer, setTokenizer] = useState<Tokenizer | null>(null);

  useEffect(() => {
    getTokenizer().then(setTokenizer).catch(() => {});
  }, []);

  const tokenize = (text: string): kuromoji.IpadicFeatures[] => {
    if (!tokenizer) return [];
    return mergeCompoundTokens(tokenizer.tokenize(text));
  };

  const getReading = (token: kuromoji.IpadicFeatures): string =>
    token.reading ? katakanaToHiragana(token.reading) : token.surface_form;

  return { tokenize, getReading, loading: !tokenizer };
}
